export type ValueOf<T> = T[keyof T];

export const OCPIConnectorFormat = Object.freeze({
  SOCKET: 'SOCKET',
  CABLE: 'CABLE'
})

export type OCPIConnectorFormatValues = ValueOf<typeof OCPIConnectorFormat>;
export type OCPIConnectorFormatKeys = keyof typeof OCPIConnectorFormat;